import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';

import { fetchAuthStatus, logout } from '../api/client.js';
import { AUTH_QUERY_KEY } from '../api/queryKeys.js';

import type { AuthStatus } from '@mixwire/contracts';

export const useAuthStatus = (): UseQueryResult<AuthStatus> =>
  useQuery({
    queryKey: AUTH_QUERY_KEY,
    queryFn: fetchAuthStatus,
    staleTime: 60_000,
  });

export const useLogout = (): UseMutationResult<AuthStatus, Error, void> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: logout,
    onSuccess: (status) => {
      queryClient.setQueryData<AuthStatus>(AUTH_QUERY_KEY, status);
    },
  });
};
